module.exports = __webpack_public_path__ + "img/pingmiantu.594fbc47.svg";